import { render, staticRenderFns } from "./retailintegraldetail.vue?vue&type=template&id=46a7aca2&scoped=true"
import script from "./retailintegraldetail.vue?vue&type=script&lang=js"
export * from "./retailintegraldetail.vue?vue&type=script&lang=js"
import style0 from "./retailintegraldetail.vue?vue&type=style&index=0&id=46a7aca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a7aca2",
  null
  
)

export default component.exports